import { always, cond, equals, T } from 'ramda';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import campaignSettingsTabs from 'features/views/campaignSettings/tabs';
import { Sidebar as CampaignSidebar } from 'pages/Campaign';
import { Sidebar as CampaignAdditionalDataSidebar } from 'pages/CampaignAdditionalData';
import CampaignSettings from 'pages/CampaignSettings';
import { Sidebar as CampaignStateSidebar } from 'pages/CampaignState';
import { Sidebar as GuarantorSidebar } from 'pages/Guarantors';
import { Sidebar as StartupCurveSidebar } from 'pages/StartupCurve';

import PageLayout from '../components/PageLayout';

const { tabs } = campaignSettingsTabs.constants;

export const CampaignSettingsPage = () => {
	const { campaignId } = useParams();
	const activeTab = useSelector(campaignSettingsTabs.selectors.getActiveTab);

	const sidebar = cond([
		[equals(tabs.STATES), always(<CampaignStateSidebar campaignId={campaignId} />)],
		[equals(tabs.GUARANTORS), always(<GuarantorSidebar campaignId={campaignId} />)],
		[equals(tabs.STARTUP_CURVE), always(<StartupCurveSidebar campaignId={campaignId} />)],
		[equals(tabs.ADDITIONAL_DATA), always(<CampaignAdditionalDataSidebar campaignId={campaignId} />)],
		[T, always(<CampaignSidebar campaignId={campaignId} />)],
	])(activeTab);

	return (
		<PageLayout aside={sidebar}>
			<div className="Page-main">
				<CampaignSettings campaignId={campaignId} />
			</div>
		</PageLayout>
	);
};

export default CampaignSettingsPage;
